import { IGambitData } from "@nkr/models/gambit-data";
import { GambitType } from "@nkr/models/gambit-type";
import { FormEvent, useEffect, useState } from "react";
import { Button, ControlLabel, FormControl, FormGroup } from "react-bootstrap";

interface IProps {
    id: number,
    gambitData: IGambitData[],
    gambitType: GambitType,
    showControlLabel: boolean,
    onTextChange: (id: number, value: string) => void,
}

export default function ConnectToDonorStatus (props: IProps) {
    const [preventFormUpdate, setPreventFormUpdate] = useState<boolean | null>(true);
    const [onHoldStatusReason, setOnHoldStatusReason] = useState<string | null>(null);
    const [savedValue, setSavedValue] = useState<string | null>(null);

    useEffect(() => {
        let collectedData =
            props.gambitData
            .filter((g) => g.gambitType === props.gambitType)[0]?.collectedData;

        setOnHoldStatusReason(collectedData);
        setSavedValue(collectedData);
    }, []);

    const handleFieldChange = (value: string) => {
        if (value === '') {
            setPreventFormUpdate(true);
        }

        setPreventFormUpdate(false);
        setOnHoldStatusReason(value);
    }

    const isDirty = onHoldStatusReason !== savedValue;

    return (
        <FormGroup validationState={onHoldStatusReason ? null : 'error'}>
            {props.showControlLabel && <ControlLabel htmlFor='onHoldStatusReason'>On Hold Reason</ControlLabel>}
            <FormControl
                id='onHoldStatusReason'
                type='text'
                name='onHoldStatusReason'
                className='form-control'
                value={onHoldStatusReason ?? ''}
                onChange={(e: FormEvent<FormControl & HTMLInputElement>) => {
                    let value = e.currentTarget.value;
                    handleFieldChange(value);
                }}
            />
            <Button
                bsStyle='primary'
                style={{ marginTop: 6 }}
                disabled={!isDirty || !onHoldStatusReason}
                onClick={() => {
                    props.onTextChange(props.id, onHoldStatusReason);
                    setSavedValue(onHoldStatusReason);
                }}
            >
                Save
            </Button>
        </FormGroup>
    );
}
